export default __webpack_public_path__ + "static/media/2018.6f08a8b1.svg";